module.exports = __webpack_public_path__ + "img/jl_logo.2a8a065d.png";